export default "__VITE_ASSET__DHk$b7Fz__"